// Footer.js
import React from 'react';
import './Footer.css';
const Footer = () => {
  return (
    <footer className="footer p-5 bg-dark ">
      <div className="container">
        <div className="row">
          <div className="col-md-4 " style={{color:"white"}}>
            <h5>About Us</h5>
            <p style={{color:"#F9EDEA"}}> We are a mobile shopping website providing the latest mobile devices and accessories.</p>
          </div>
          <div className="col-md-4" style={{color:"#F9EDEA"}}>
            <h5 >Contact Us</h5>
            <p style={{color:"#F9EDEA"}}>Email: info@example.com</p>
            <p style={{color:"#F9EDEA"}}>Phone: 123-456-7890</p>
          </div>
          <div className="col-md-4" >
            <h5>Follow Us</h5>
            <p style={{color:"#F9EDEA"}}>Connect with us on social media:</p>
            <ul className="list-inline w-50 d-flex align-items-center justify-content-center" style={{backgroundColor:"#ffcc00",borderRadius:"20px"}}>
              <li className="list-inline-item bg-light p-1"style={{borderRadius:"50%"}}><i class="bi bi-facebook "></i></li>
              <li className="list-inline-item bg-light p-1" style={{borderRadius:"50%" }}><i class="bi bi-twitter"></i></li>
              <li className="list-inline-item bg-light p-1" style={{borderRadius:"50%" }}><i class="bi bi-instagram"></i></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="text-center p-3" style={{ backgroundColor: '#ffffff' ,borderRadius:"20px"}}>
       
        <span >Developed amd maintained by Jagadeesh   </span>© {new Date().getFullYear()} Mobile Shop. All rights reserved.
      </div>
      
    </footer>
  );
};

export default Footer;
